import { render, staticRenderFns } from "./IntegrationHint.vue?vue&type=template&id=1b4956f0&scoped=true&"
import script from "./IntegrationHint.vue?vue&type=script&lang=js&"
export * from "./IntegrationHint.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationHint.vue?vue&type=style&index=0&id=1b4956f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4956f0",
  null
  
)

export default component.exports